import { useQuery } from '@apollo/client/react';
import { useHostAuth } from '../../shared/ui';
import { DISTRIBUTOR_QUERY } from './graphql/queries';
import type { Distributor, DistributorQueryData } from './types';

/**
 * The signed-in distributor.
 *
 * The Angular host already holds this in its store, but looking it up here
 * keeps the remote self-contained: the same component renders when the app is
 * served on its own, where there is no store to read.
 */
export function useDistributor(): {
  distributor: Distributor | null;
  loading: boolean;
  error?: { message: string };
} {
  const { user, isAuthenticated } = useHostAuth();
  const { data, loading, error } = useQuery<DistributorQueryData>(DISTRIBUTOR_QUERY, {
    variables: { uuid: user?.companyUuid },
    skip: !isAuthenticated || !user?.companyUuid,
  });

  return { distributor: data?.distributorByUuid ?? null, loading, error };
}
